export const goToCloudPreview = 'https://app.getambassador.io/cloud/preview';

export const goToContactUs = '/contact-us';

export const goToTelepresence = '/products/telepresence';

export const goToTutorialsGettingStarted = '/docs/latest/tutorials/getting-started';

export const goToTelepresenceQuickStart = '/docs/latest/telepresence/quick-start/ ';

export const goToEdgeStack = '/products/edge-stack';

export const goToDeveloperPortal = '/products/developer-portal';

export const goToServiceCatalogProduct = '/products/service-catalog';

export const goToGithubAmbassador = 'https://github.com/datawire/ambassador';

export const goToGithubTelepresence = 'https://github.com/telepresenceio/telepresence';

export const goToGithubDocs = 'https://github.com/datawire/ambassador-docs/blob/master/docs/1.11/index.md';

export const goTolatestDoc = '/docs/latest';

export const goToSlack = 'https://d6e.co/slack';

export const goToGetAmbassador = 'https://app.getambassador.io';

export const goToTelepresenceDocs = '/docs/latest/telepresence/quick-start/';

export const goToTelepresenceHowTo = '/docs/latest/telepresence/howtos/preview-urls/';

export const goToTelepresenceEnv = '/docs/latest/telepresence/reference/environment/';

export const goToTelepresenceOutbound = '/docs/latest/telepresence/howtos/outbound/';

export const goToMappings = '/docs/latest/topics/using/intro-mappings/';

export const goToOauth = '/docs/latest/howtos/oauth-oidc-auth/';

export const goToRateLimits = '/docs/latest/topics/using/rate-limits/rate-limits/';
